var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3.12918C8.44387 3.12918 3.12912 8.44394 3.12912 15C3.12912 21.5561 8.44387 26.8709 15 26.8709C21.556 26.8709 26.8708 21.5561 26.8708 15C26.8708 8.44394 21.556 3.12918 15 3.12918ZM1.87079 15C1.87079 7.74898 7.74892 1.87085 15 1.87085C22.251 1.87085 28.1291 7.74898 28.1291 15C28.1291 22.2511 22.251 28.1292 15 28.1292C7.74892 28.1292 1.87079 22.2511 1.87079 15Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8749 15.6292H8.12494V14.3708H21.8749V15.6292Z",
    fill: "#B41730"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3708 21.875V8.125H15.6291V21.875H14.3708Z",
    fill: "#B41730"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle_plus.59bf5f81.svg";
export { ForwardRef as ReactComponent };